export class LogList{
  readonly logs: Log[]=[];

  empty(){
    this.logs.splice(0, this.logs.length);;
  }

  add(text: string, type: LogType='text', pre: string='>'){
    this.logs.push(new Log(text, type, pre));
  }

  addLogList(list: LogList){
    list.logs.forEach(l => this.logs.push(l));
  }

  addWrapLogs(logs: LogServeur[], pre: string='>'){
    this.logs.push(...logs.map(l => LogList.wrapLog(l)));
  }

  static wrapLog(log: LogServeur, pre: string='>'){
    let logType: LogType='text';
    switch(log.level){
      case 2:
          logType='warning';
          break;
      case 3:
          logType='error';
          break;
      default:
          logType='text';
    }
    return new Log(log.text, logType);
  }
}

export type LogType='text' | 'success' | 'info' | 'warning' | 'error';

export class Log{
  constructor(
    public text: string,
    public type: LogType='text',
    public pre: string='>',
  ){ }
}

/*  
  const LOG_LEVEL_INFO=1;
  const LOG_LEVEL_WARNING=2;
  const LOG_LEVEL_DANGER=3;
  const LOG_LEVEL_TITLE=4;
*/
export type LogTypeServeur=1 | 2 | 3 | 4 | 5;

export class LogServeur{
  text: string;
  level: LogTypeServeur;
  date: Date;
}

export class Payload{
  index: number;				//index du payload commence à 0
  titre: string;
  state: 'Error' | 'Valide';
  next?: number=null;			//null si fin
  logs: LogServeur[];
  datas?: any=null;
}

export class Notification{
  text: string;
  type: NotifType;
}

export type NotifType='info' | 'error' | 'success';

export class ApiKey{
  ident: string;
  app: string;
  key: string;
  state: 'valid' | 'disabled' | 'removed';
}
